export default class {

    Id = null;

    Name = null;

    IsParent = false;

    ParentId = null;

    SubSectionId = null;

    Activities = [];

    SubTags = [];

    mapFromDto(modelDto) {
        if(!modelDto)
            return this;

        this.Id = modelDto.Id;
        this.Name = modelDto.Name;
        this.IsParent = modelDto.IsParent;
        this.ParentId = modelDto.ParentId;
        this.SubSectionId = modelDto.SubSectionId;
        this.Activities = modelDto.Activities;
        this.SubTags = modelDto.SubTags;

        return this;
    }

    getObjects(objects) {

        if(this.IsParent) {
            let subTagIdsClone = JSON.parse(JSON.stringify(this.SubTags));
            this.SubTags = [];

            subTagIdsClone.forEach(e => {
                this.SubTags.push(objects.find(o => o.Id == e));
            });
        }
        else {
            let activityIdsClone = JSON.parse(JSON.stringify(this.Activities));
            this.Activities = [];

            activityIdsClone.forEach(e => {
                this.Activities.push(objects.find(o => o.Id == e));
            });
        }

    }

    isValid() {

        return this.IsParent
                    ? Boolean(this.Name) && Boolean(this.SubTags) && Boolean(this.SubTags.length)
                    : Boolean(this.Name) &&  Boolean(this.ParentId) && 
                                             Boolean(this.SubSectionId) && 
                                             Boolean(this.Activities) && 
                                             Boolean(this.Activities.length);
    }

    mapToDto() {
        let result = JSON.parse(JSON.stringify(this));

        if(!result.IsParent) {

            result.ParentId = result.ParentId.Id;

            result.SubSectionId = result.SubSectionId.Id;

            if(result.Activities && result.Activities.length)
                result.Activities = result.Activities.map(e => e.Id);
        }
        

        if(result.IsParent && result.SubTags && result.SubTags.length)
            result.SubTags = result.SubTags.map(e => e.Id);

        return result;
    }
}